/* eslint-disable */ 

import axios from 'axios';

const SERVICE = "/boleto";

export default {    
    salvar: ({ commit }, payload) => {
        return axios.post(SERVICE, payload)  
                    .then(resp => resp.data);                    
    },
    atualizar: ({commit}, payload) => {
        return axios.put(SERVICE + "/" + payload.id, payload)  
                    .then(resp => resp.data);                    
    },
    remover: ({commit}, payload) => {        
        return axios.delete(SERVICE + "/" + payload)  
                    .then(resp => resp.data);                    
    },
    obterPorCpf: ({commit}, payload) => {
        return axios.get(SERVICE + "/cpf/" + payload)  
                    .then(resp => resp.data);                    
    },
}